const UnknownPhysDescriptionFieldConfig = [];

export default UnknownPhysDescriptionFieldConfig;
